"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleAggregateLookupNode = void 0;
const NODE_TYPE = 'SINGLE-AGGREGATE-LOOKUP';
const BaseNode_1 = require("../../BaseNode");
const LookupHelper_1 = require("../LookupHelper");
const Schema = __importStar(require("./schema.json"));
const ID_KEY = 'id';
class SingleAggregateLookupNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            var _a, _b, _c, _d;
            const { aggregateType, strategy } = this.config;
            const strategyToUse = strategy || LookupHelper_1.LookupConfigSchema.default;
            if ((0, LookupHelper_1.hasStrategyPreReqs)(strategyToUse, (_a = this.accessorMap) === null || _a === void 0 ? void 0 : _a.ONLINE_ATTRIB_LOOKUP, (_b = this.accessorMap) === null || _b === void 0 ? void 0 : _b.OFFLINE_ATTRIB_LOOKUP)) {
                const inputs = await this.asynchronousResolveInputs(nodeMap);
                const { aggregateId, skipEvaluation } = inputs;
                if (!skipEvaluation) {
                    const value = await (0, LookupHelper_1.lookupValue)((_c = this.accessorMap) === null || _c === void 0 ? void 0 : _c.ONLINE_ATTRIB_LOOKUP, (_d = this.accessorMap) === null || _d === void 0 ? void 0 : _d.OFFLINE_ATTRIB_LOOKUP, strategyToUse, {
                        aggregateType,
                        attributeName: ID_KEY,
                        attributeValue: aggregateId,
                        limit: 1,
                    });
                    return Object.assign({ successfulLookup: value.lookupSucceeded }, value.results[0]);
                }
            }
            // Accessor was not available, can not run this transform
            return {
                successfulLookup: false,
            };
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Single aggregate lookup is not allowed as a synchronously resolving node');
        };
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        var _a;
        //grab the available aggregate types if available
        const aggregateTypes = this.schemaLookup.getAggregates && this.schemaLookup.getAggregates();
        let outputParams = {}; // This may make more sense eventually Schema.definitions.InputParams as JSONSchema6;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.aggregateType) {
            // we use this trick to get a full copy of the schema. This may end up being too slow, but let's try for now.
            outputParams = JSON.parse(JSON.stringify(this.schemaLookup.getSchema(this.config.aggregateType) || {}));
            // We need to remove the metadata section because this is populated by the command processor.
            //  Technically we could probably leave it, but I don't see enough value in it to confuse the mapper user
            if (outputParams.properties) {
                delete outputParams.properties.metadata;
                //Also, add in the success boolean
                outputParams.properties = Object.assign({ successfulLookup: { type: 'boolean', description: 'Lookup Successful?' } }, outputParams.properties);
            }
        }
        return Object.assign(Object.assign({}, Schema.definitions), { ConfigParams: {
                type: 'object',
                properties: {
                    strategy: LookupHelper_1.LookupConfigSchema,
                    aggregateType: {
                        description: 'Aggregate Type',
                        type: 'string',
                        enum: aggregateTypes || undefined,
                    },
                },
            }, OutputParams: outputParams });
    }
}
exports.SingleAggregateLookupNode = SingleAggregateLookupNode;
SingleAggregateLookupNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Single Aggregate Lookup',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=SingleAggregateLookup.js.map